import { useState } from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import ResponsiveSidebar from './ResponsiveSidebar';
import Topbar from './Topbar';
import PulseStrip from './PulseStrip';
import { tokens } from '../../theme/theme';

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: tokens.bg.default }}>
      <ResponsiveSidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Topbar onMenu={() => setMobileOpen(true)} />
        <PulseStrip />
        <Box component="main" sx={{ flexGrow: 1, p: { xs: 1.5, sm: 2, md: 3 }, overflowX: 'hidden' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
